function stop_animation() {
  current_direction = 0;
  clearInterval(interval);
}

function showCalibrate()
{
  screenType = "calibration";

          show("line");
          line = document.getElementById('line');
          document.onkeydown = function(e) {

          //var key_code = window.event ? event.keyCode : e.keyCode;
          var key_code = e.keyCode ? e.keyCode : e.which ? e.which : e.charCode;

          // shift bar by 2 pixels to the right or left
          var direction = (key_code - 38);

          // left - 37, right - 39
          if ((key_code == 37 || key_code == 39) && (current_direction != direction)) {
            clearInterval(interval);
            current_direction = direction;
            interval = setInterval(function() {
              var w = parseInt(line.style.width) + direction;
              if (w >= 10) {
                line.style.width = w + "px";
              } else {
                stop_animation();
              }
            }, 10);
          }

        document.onkeyup = stop_animation;

        }


        displayText("title",textScreens[screenType][language][0]);
        //show("content-title");//added by Dabiel; why??
        displayText("content",textScreens[screenType][language][1]);//nothing displayed if na
        showOneButtonStandard(textScreens[screenType][language][2]);
}

function endCalibrate()
{
  //get density
  var ref_size = 430;
  adjuster = Math.round(parseInt(line.style.width)/ref_size*100)/100;
  saveInfo.push(adjuster);
  saveInfoColumns.push('calibration');

  tempCanvasWidth = $('#displayScreen').width();
  tempCanvasHeight = $('#displayScreen').height();
  newDisplayScreenWidth = Math.round((tempCanvasWidth*adjuster));
  newDisplayScreenHeight = Math.round((tempCanvasHeight*adjuster));
  newDisplayScreenMargin = (-newDisplayScreenHeight/2) + "px 0 0 " + (-newDisplayScreenWidth/2) +"px";
    // daniel added 50px here; why??
    // newCanvasMargin = ((-tempCanvasHeight/2*adjuster)+50) + "px 0 0 " + (-tempCanvasWidth/2*adjuster) +"px";
  newDisplayScreenFontSize = Math.round(textSize_setup*adjuster);
  textSize_setup = Math.round(textSize_setup*adjuster);

  // if(screen.availWidth>1000 && 1000*adjuster<screen.availWidth)//make sure enough resolution
    if(1)//make sure enough resolution
  {
  document.getElementById("displayScreen").style.width = newDisplayScreenWidth + "px";
  document.getElementById("displayScreen").style.height = newDisplayScreenHeight + "px";
  document.getElementById("displayScreen").style.fontSize = newDisplayScreenFontSize + "px";

  setDisplayVariables(adjuster);

    screen_calibrate="na";
    hide("line");hide("button1");hide("title");hide("content");
    //hide("content-title");//added by DAniel; why??

    main();
  }
  else {hide("line");terminate();}
}


function sendStartAnalytics() {
    if (!trackAnalyticsEvent) {
        console.error('trackAnalyticsEvent is not defined');
        return;
    }

    trackAnalyticsEvent('Experiment', {
        'event': 'start',
        'name': window.experimentName,
    });

    if (loggedUserId == 0) {
        trackAnalyticsEvent('Experiment', {
            'event': 'start_not_user',
            'name': window.experimentName,
        });
        return;
    }

    if (loggedUserId == window.experimenterId) {
        trackAnalyticsEvent('Experiment', {
            'event': 'start_owner',
            'name': window.experimentName,
        });
        return;
    }

    trackAnalyticsEvent('Experiment', {
        'event': 'start_cross_user',
        'name': window.experimentName,
    });
}

function sendEndAnalytics() {
    trackAnalyticsEvent('Experiment', {
        'event': 'end',
        'name': window.experimentName,
    });

    if (loggedUserId == 0) {
        trackAnalyticsEvent('Experiment', {
            'event': 'end_not_user',
            'name': window.experimentName,
        });
        return;
    }

    if (loggedUserId == window.experimenterId) {
        trackAnalyticsEvent('Experiment', {
            'event': 'end_owner',
            'name': window.experimentName,
        });
        return;
    }

    trackAnalyticsEvent('Experiment', {
        'event': 'end_cross_user',
        'name': window.experimentName,
    });
}